/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.hostname = window.location.origin;

// window.$ = window.jQuery = require('jquery');
require('./bootstrap');
require('./polyfill.min.js');


// require('jquery-ui');
// require('jquery-ui/ui/widgets/autocomplete');
// require('jquery-ui/ui/widgets/datepicker');
// require('jquery-ui/ui/i18n/datepicker-fr');
// require('jquery-datetimepicker');

// require('admin-lte');

// require('datatables.net-bs4');

require('./custom/autocomplete');
require('./custom/only-submit-once');
require('./functions');
require('./dragndrop');
require('./custom/password');
$(function () {
    $('body').tooltip({selector: '[data-toggle="tooltip"]'});
    // $('.collapse').collapse()
    $('.collapse').not('.custom_menu .collapse,.project-task-phase,.regie-task-collapse').collapse();
});

// Ziggy.baseUrl = location.protocol+'//'+location.hostname;
// Ziggy.baseProtocol = location.protocol;
// Ziggy.baseDomain = location.hostname;

require('./custom/todolist');
